export type PromiseOrValue<T> = Promise<T> | T;

export type PickNonNullable<T, Keys extends keyof T> = T &
  NonNullableObject<Required<Pick<T, Keys>>>;

export type NonNullableObject<T> = Required<{
  [K in keyof T]: NonNullable<T[K]>;
}>;

export const DEPOSIT_TX_PREFIX = '0x7E';

export enum SourceHashDomain {
  UserDeposit = 0,
  L1InfoDeposit = 1,
}

export type TypeFromGraphQLUnion<
  Union extends { __typename: string },
  Typename extends string,
> = Union extends {
  __typename: Typename;
}
  ? Union
  : never;

export type PlaylistReferral = {
  playlistId: string;
  playlistUserAddress: string;
};
